import { Button, Form, Input, Typography, message } from "antd";
import { useTranslation } from "react-i18next";
import React from "react";
import { ApiService } from "../../api";
import { useNavigate } from "react-router-dom";

const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const handleSubmit = async (values: any) => {
    try {
      ApiService.apiPasswordResetCreate({ email: values.email });
      message.success(t("Reset password email has been send successfully"));
      navigate("/login");
    } catch (e) {
      message.error(t("Something went wrong."));
    }
  };

  return (
    // The old `marginLeft: 40%` faked centring and drifted with the viewport;
    // LoginLayout now centres this properly, so it just needs a width.
    <Form
      form={form}
      onFinish={handleSubmit}
      layout="vertical"
      style={{ width: 320 }}
    >
      {/* A short title plus muted helper text, rather than an Alert: alerts
          signal that something happened, so using one for standing instructions
          shouts at the user every visit and competes with the field itself. */}
      <Typography.Title level={4} style={{ marginTop: 0 }}>
        {t("Reset password")}
      </Typography.Title>
      <Typography.Paragraph type="secondary">
        {t("Enter your email and we will send you a link to reset your password.")}
      </Typography.Paragraph>
      <Form.Item name="email" label={t("Email")}>
        <Input />
      </Form.Item>
      <Form.Item style={{ marginBottom: 0 }}>
        <Button type="primary" htmlType="submit" className="login-form-button">
          {t("Send email")}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ForgotPasswordPage;
